module.exports = __webpack_public_path__ + "static/media/kinsta.651e0487.png";